import { useQuery } from "@tanstack/react-query";
import SysUser from "app/class/sysUser";
import { isSessionAlive } from "app/services/http-services/request-backend-api";
import queryKeys from "shared/services/queryKeys";

// Module-level so the identity is stable: an inline `select` is re-run on every render and
// `new SysUser()` is never structurally shared, which re-notifies the observer in a loop.
const selectSessionUser = (response: Awaited<ReturnType<typeof isSessionAlive>>) => {
    if (!response) return null;
    return new SysUser().fromJson(response.data);
};

export const useSession = () => {
    return useQuery({
        queryKey: queryKeys.session.me(),
        queryFn: isSessionAlive,
        staleTime: 1000 * 30,
        retry: false,
        select: selectSessionUser,
    });
};
